import React, { Component } from "react";
import { MDBInput, MDBTextArea, MDBBtn, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import { mfmFramedUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import RichTextEditor from "Projects/CC_cubi_clan_project/GlobalComponents/RichTextEditor/RichTextEditor";
import ModalPortal from "./ModalPortal";
import "./CastItemModal.css";

const PORTRAIT_FORMAT_KEY = "ratio:3:4";

// ===== Helpers =====
const stripDataUrl = (dataUri) =>
  dataUri && String(dataUri).startsWith("data:image")
    ? String(dataUri).replace(/^data:image\/[a-zA-Z0-9+.+-]+;base64,/, "")
    : dataUri || "";
const toDataUrl = (b64) =>
  b64 ? (String(b64).startsWith("data:") ? b64 : `data:image/jpeg;base64,${b64}`) : "";
const clone = (o) => JSON.parse(JSON.stringify(o || {}));
const normalizeStr = (s) => String(s || "").trim().toLowerCase();

/** Garantiza la estructura mínima del modelo personaje + rol[0] + actor */
const ensureModel = (item) => {
  const base = {
    idPersonaje: null,
    name: "",
    status: "published",
    description: "",
    imageBase64: "",
    imageUuid: null,
    roles: [
      {
        idRol: null,
        imageBase64: "",
        imageUuid: null,
        status: "published",
        actor: { idActor: null, name: "", bio: "", imageBase64: "", imageUuid: null },
      },
    ],
  };
  const m = { ...base, ...(item || {}) };
  if (!Array.isArray(m.roles) || m.roles.length === 0) m.roles = clone(base.roles);
  if (!m.roles[0].actor) m.roles[0].actor = clone(base.roles[0].actor);
  if (normalizeStr(m.status) !== "published" && normalizeStr(m.status) !== "draft") m.status = "published";
  if (normalizeStr(m.roles[0].status) !== "published" && normalizeStr(m.roles[0].status) !== "draft") {
    m.roles[0].status = "published";
  }
  m.imageBase64 = stripDataUrl(m.imageBase64 || "");
  m.roles[0].imageBase64 = stripDataUrl(m.roles[0].imageBase64 || "");
  m.roles[0].actor.imageBase64 = stripDataUrl(m.roles[0].actor.imageBase64 || "");
  return m;
};

export default class CastItemModal extends Component {
  constructor(props) {
    super(props);
    const safe = ensureModel(props.item);

    this.state = {
      item: clone(safe),
      personajePreview: toDataUrl(safe.imageBase64),
      rolePreview: toDataUrl(safe.roles[0].imageBase64),
      actorPreview: safe.roles[0].actor?.imageUuid
        ? mfmFramedUrl(safe.roles[0].actor.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY)
        : "",
      allActors: [],
      actorQuery: safe.roles[0].actor?.name || "",
      showActorList: false,
      filteredActors: [],
      errors: {},
      loadingActors: false,
      confirmingDelete: false,
    };

    this.inputRef = React.createRef();
    this.listRef = React.createRef();
  }

  componentDidMount() {
    document.body.classList.add("modal-open");
    this.loadActors();
  }
  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item !== this.props.item) {
      const safe = ensureModel(this.props.item);
      this.setState({
        item: clone(safe),
        personajePreview: toDataUrl(safe.imageBase64),
        rolePreview: toDataUrl(safe.roles[0].imageBase64),
        actorPreview: safe.roles[0].actor?.imageUuid
          ? mfmFramedUrl(safe.roles[0].actor.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY)
          : "",
        actorQuery: safe.roles[0].actor?.name || "",
        showActorList: false,
        errors: {},
      });
    }
  }

  // ====== Carga de actores ======
  loadActors = async () => {
    try {
      this.setState({ loadingActors: true });
      const { doFetch } = require("Projects/CC_cubi_clan_project/Utils/ConnectionManager");
      const resp = await doFetch("MUGIN", "getActors", { method: "GET" });
      const json = await resp.json().catch(() => ({}));
      const rows = Array.isArray(json?.DATA) ? json.DATA : [];

      const actors = rows.filter((a) => {
        const st = normalizeStr(a?.status);
        return st === "published" || st === "active" || st === "enabled";
      });
      this.setState({ allActors: actors }, () => this.recomputeFilter());
    } catch (e) {
      console.error("CastItemModal.loadActors error", e);
    } finally {
      this.setState({ loadingActors: false });
    }
  };

  // ====== Edición ======
  onField = (path, value) => {
    this.setState((prev) => {
      const it = clone(prev.item);
      switch (path) {
        case "personaje.name":        it.name = value; break;
        case "personaje.status":      it.status = value; break;
        case "personaje.description": it.description = value; break;
        case "role.notes":            it.roles[0].notes = value; break;
        default: break;
      }
      return { item: it };
    });
  };

  onPersonajeImage = (dataUrl) => {
    const b64 = stripDataUrl(dataUrl || "");
    this.setState((prev) => {
      const it = clone(prev.item);
      it.imageBase64 = b64;
      return { item: it, personajePreview: dataUrl || "" };
    });
  };
  clearPersonajeImage = () => {
    this.setState((prev) => {
      const it = clone(prev.item);
      it.imageBase64 = "";
      it.imageUuid = null;
      return { item: it, personajePreview: "" };
    });
  };

  onPersonajeUuid = (uuid) => {
    this.setState((prev) => {
      const it = clone(prev.item);
      it.imageUuid = uuid;
      it.imageBase64 = "";
      return { item: it };
    });
  };

  onRoleImage = (dataUrl) => {
    const b64 = stripDataUrl(dataUrl || "");
    this.setState((prev) => {
      const it = clone(prev.item);
      it.roles[0].imageBase64 = b64;
      return { item: it, rolePreview: dataUrl || "" };
    });
  };
  clearRoleImage = () => {
    this.setState((prev) => {
      const it = clone(prev.item);
      it.roles[0].imageBase64 = "";
      it.roles[0].imageUuid = null;
      return { item: it, rolePreview: "" };
    });
  };

  onRoleUuid = (uuid) => {
    this.setState((prev) => {
      const it = clone(prev.item);
      it.roles[0].imageUuid = uuid;
      it.roles[0].imageBase64 = "";
      return { item: it };
    });
  };

  // ====== Typeahead de Actor ======
  openActorList = () => this.setState({ showActorList: true }, this.recomputeFilter);
  closeActorList = () => this.setState({ showActorList: false });

  onActorQuery = (value) => {
    this.setState({ actorQuery: value }, this.recomputeFilter);
  };

  recomputeFilter = () => {
    const { allActors, actorQuery } = this.state;
    const q = normalizeStr(actorQuery);
    const filtered = !q ? allActors : allActors.filter((a) => normalizeStr(a.name).includes(q));
    this.setState({ filteredActors: filtered });
  };

  selectActor = (actor) => {
    this.setState(
      (prev) => {
        const it = clone(prev.item);
        it.roles[0].actor = {
          idActor: actor.idActor,
          name: actor.name,
          bio: actor.bio,
          imageBase64: stripDataUrl(actor.imageBase64 || ""),
          imageUuid: actor.imageUuid || null,
        };
        return {
          item: it,
          actorPreview: actor.imageUuid
            ? mfmFramedUrl(actor.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY)
            : "",
          actorQuery: actor.name,
          showActorList: false,
        };
      },
      () => this.inputRef.current?.blur()
    );
  };

  onActorBlur = () => {
    const { actorQuery, allActors, item } = this.state;
    const exact = allActors.find((a) => normalizeStr(a.name) === normalizeStr(actorQuery));
    if (exact) {
      if ((item.roles?.[0]?.actor?.idActor || null) !== exact.idActor) {
        this.selectActor(exact);
      }
      this.closeActorList();
      return;
    }
    this.setState((prev) => {
      const it = clone(prev.item);
      it.roles[0].actor = { idActor: null, name: "", bio: "", imageBase64: "" };
      return { item: it, actorQuery: "", actorPreview: "" };
    });
    this.closeActorList();
  };

  onListMouseDown = (e) => e.preventDefault();

  // ====== Toggle estado ======
  handleTogglePersonajeStatus = () => {
    this.setState((prev) => {
      const it = clone(prev.item);
      const current = it.status || "draft";
      it.status = current === "published" ? "draft" : "published";
      return { item: it };
    });
  };

  // ====== Confirmación de eliminación ======
  handleDeleteClick = () => this.setState({ confirmingDelete: true });
  handleDeleteCancel = () => this.setState({ confirmingDelete: false });

  handleDeleteConfirm = () => {
    this.setState({ confirmingDelete: false });
    if (typeof this.props.onDelete === "function") this.props.onDelete(this.buildPayload());
  };

  handleDisableInstead = () => {
    this.setState((prev) => {
      const it = clone(prev.item);
      it.status = "draft";
      return { item: it, confirmingDelete: false };
    });
  };

  // ====== Validación y guardado ======
  validate = () => {
    const { item } = this.state;
    const errors = {};
    if (!item.name?.trim()) errors.personaje_name = "El nombre del personaje es obligatorio";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  buildPayload = () => {
    const it = clone(this.state.item);
    it.imageBase64 = stripDataUrl(it.imageBase64 || "");
    // Procesar TODOS los roles para no perder datos al guardar
    if (Array.isArray(it.roles) && it.roles.length > 0) {
      for (let i = 0; i < it.roles.length; i++) {
        it.roles[i].imageBase64 = stripDataUrl(it.roles[i].imageBase64 || "");
        it.roles[i].status = "published";
        it.roles[i].actor = it.roles[i].actor || {};
        it.roles[i].actor.imageBase64 = stripDataUrl(it.roles[i].actor.imageBase64 || "");
      }

      // No enviar rol "placeholder" cuando no hay actor asignado.
      it.roles = it.roles.filter((r) => {
        const hasPersistedRole = r?.idRol != null;
        const hasActor = r?.actor?.idActor != null;
        return hasPersistedRole || hasActor;
      });
    } else {
      it.roles = [];
    }
    return it;
  };

  handleSave = () => {
    if (!this.validate()) return;
    this.props.onSave && this.props.onSave(this.buildPayload());
  };

  render() {
    const { onClose, onDelete } = this.props;
    const {
      item, errors,
      personajePreview, rolePreview, actorPreview,
      actorQuery, showActorList, filteredActors, loadingActors,
      confirmingDelete,
    } = this.state;

    const hasActor = !!item.roles?.[0]?.actor?.idActor;
    const hasRole = !!item.roles?.[0] && (hasActor || item.roles?.[0]?.idRol != null);
    const isPersonajeDraft = (item.status || "draft") === "draft";

    return (
      <ModalPortal>
        <>
          <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
              {/* ===== Cabecera: título ===== */}
              <div className="cast-modal-header">
                <h4 className="cast-modal-title mb-0">Editar reparto</h4>
              </div>

              {/* ===== Cuerpo: izquierda (campos) / derecha (foto personaje) ===== */}
              <div className="cast-modal-body">
                <div className="cast-modal-left">
                  {/* Nombre del personaje */}
                  <MDBInput
                    label="Nombre del personaje"
                    className="mb-2"
                    value={item.name || ""}
                    onChange={(e) => this.onField("personaje.name", e.target.value)}
                  />
                  {errors.personaje_name && (
                    <div className="text-danger small mb-2">{errors.personaje_name}</div>
                  )}

                  {/* Intérprete (actor) */}
                  <div className="cast-modal-section">
                    <h6 className="cast-modal-section-title">Intérprete</h6>
                    <div className="actor-typeahead">
                      <MDBInput
                        inputRef={this.inputRef}
                        label="Buscar actor"
                        value={actorQuery}
                        onChange={(e) => this.onActorQuery(e.target.value)}
                        onFocus={this.openActorList}
                        onBlur={this.onActorBlur}
                        disabled={loadingActors}
                      />
                      {showActorList && (
                        <div className="actor-list" ref={this.listRef} onMouseDown={this.onListMouseDown}>
                          {filteredActors.length === 0 ? (
                            <div className="actor-empty">Sin resultados</div>
                          ) : (
                            filteredActors.map((a) => (
                              <div key={a.idActor} className="actor-item" onClick={() => this.selectActor(a)}>
                                <div className="actor-thumb">
                                  {a.imageUuid
                                    ? <img alt="Miembro" src={mfmFramedUrl(a.imageUuid, 72, 96, PORTRAIT_FORMAT_KEY)} />
                                    : a.imageBase64
                                      ? <img alt="Miembro" src={toDataUrl(a.imageBase64)} />
                                      : <div className="actor-noimg" />}
                                </div>
                                <div className="actor-data">
                                  <div className="actor-name">{a.name}</div>
                                  {a.bio ? <div className="actor-bio">{a.bio}</div> : null}
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      )}
                      <div className="text-muted small mt-1">
                        Opcional. Si no seleccionas intérprete, se guardará solo el personaje.
                      </div>
                    </div>
                  </div>

                  {/* Descripción del personaje */}
                  <div className="cast-modal-section">
                    <label className="form-label fw-bold d-block mb-1" style={{ fontSize: "0.85rem" }}>
                      Descripción
                    </label>
                    <RichTextEditor
                      initialHtml={item.description || ""}
                      onChangeHtml={(html) => this.onField("personaje.description", html)}
                      height={120}
                      appCode="MUGIN"
                    />
                  </div>

                  {/* Notas del rol */}
                  <MDBTextArea
                    label="Notas del rol"
                    rows={2}
                    value={item.roles?.[0]?.notes || ""}
                    onChange={(e) => this.onField("role.notes", e.target.value)}
                  />
                </div>

                {/* Columna derecha: foto del personaje */}
                <div className="cast-modal-right">
                  <div className="cast-uploader-wrap cast-uploader-personaje">
                    <MfmImageUploader
                      uuid={item.imageUuid || null}
                      appCode="MUGIN"
                      library="Maestros"
                      size="medium"
                      mediaFormat="3/4"
                      mediaFrameSize="270x360"
                      onUpload={(result) => this.onPersonajeUuid(result.uuid)}
                      onDelete={() => this.onPersonajeUuid(null)}
                      style={{ width: "100%", aspectRatio: "3/4", borderRadius: 8 }}
                    />
                  </div>
                </div>
              </div>

              {/* ===== Fotos del rol y actor ===== */}
              {hasActor && (
                <div className="cast-modal-section">
                  <h6 className="cast-modal-section-title">Fotos</h6>
                  <MDBRow className="g-3">
                    <MDBCol sm="6">
                      <div className="small fw-semibold mb-1">Foto del rol</div>
                      <div className="cast-uploader-wrap cast-uploader-constrained">
                        <MfmImageUploader
                          uuid={item.roles?.[0]?.imageUuid || null}
                          appCode="MUGIN"
                          library="roles"
                          size="medium"
                          mediaFormat="3/4"
                          mediaFrameSize="270x360"
                          onUpload={(result) => this.onRoleUuid(result.uuid)}
                          onDelete={() => this.onRoleUuid(null)}
                          style={{ width: "100%", aspectRatio: "3/4", borderRadius: 8 }}
                        />
                      </div>
                    </MDBCol>
                    <MDBCol sm="6">
                      <div className="small fw-semibold mb-1">Foto del actor (solo lectura)</div>
                      <div className="cast-uploader-wrap cast-uploader-constrained">
                        {item.roles?.[0]?.actor?.status === "published" && item.roles?.[0]?.actor?.imageUuid ? (
                          <img
                          src={mfmFramedUrl(item.roles[0].actor.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY)}
                            alt="Miembro"
                            style={{ width: "100%", aspectRatio: "3/4", objectFit: "cover", borderRadius: 8 }}
                          />
                        ) : item.roles?.[0]?.actor?.status === "published" && actorPreview ? (
                          <img
                            src={actorPreview}
                            alt="Miembro"
                            style={{ width: "100%", aspectRatio: "3/4", objectFit: "cover", borderRadius: 8 }}
                          />
                        ) : (
                          <div className="cast-actor-noimg" />
                        )}
                      </div>
                    </MDBCol>
                  </MDBRow>
                </div>
              )}

              {/* ===== Botonera ===== */}
              <div className="cast-modal-actions">
                <div className="d-flex gap-2">
                  {onDelete && (
                    <MDBBtn color="danger" outline size="sm" onClick={this.handleDeleteClick}>
                      Eliminar
                    </MDBBtn>
                  )}
                  <MDBBtn
                    color={isPersonajeDraft ? "success" : "warning"}
                    outline
                    size="sm"
                    onClick={this.handleTogglePersonajeStatus}
                  >
                    {isPersonajeDraft ? "Publicar" : "Despublicar"}
                  </MDBBtn>
                </div>
                <div className="d-flex gap-2">
                  <MDBBtn color="secondary" onClick={onClose}>
                    Cancelar
                  </MDBBtn>
                  <MDBBtn className="mugin-btn-primary" onClick={this.handleSave}>
                    Guardar
                  </MDBBtn>
                </div>
              </div>
            </div>
          </div>

          {/* ===== Confirmación de eliminación ===== */}
          {confirmingDelete && (
            <div className="cast-delete-overlay" onClick={this.handleDeleteCancel}>
              <div className="cast-delete-card" onClick={(e) => e.stopPropagation()}>
                <h6 className="mb-2">¿Eliminar este personaje/rol?</h6>
                <p className="text-muted small mb-3">
                  Considera <strong>despublicar</strong> el personaje en lugar de eliminarlo.
                  Los personajes despublicados no se muestran al público pero se pueden recuperar.
                </p>
                <div className="d-flex gap-2 justify-content-end">
                  <MDBBtn size="sm" color="secondary" onClick={this.handleDeleteCancel}>
                    Cancelar
                  </MDBBtn>
                  <MDBBtn size="sm" color="warning" onClick={this.handleDisableInstead}>
                    Despublicar
                  </MDBBtn>
                  <MDBBtn size="sm" color="danger" onClick={this.handleDeleteConfirm}>
                    Eliminar
                  </MDBBtn>
                </div>
              </div>
            </div>
          )}
        </>
      </ModalPortal>
    );
  }
}
